module.exports = __webpack_public_path__ + "img/13.a38fffb9.png";